@if (!importing) {
  <app-modal-header [hasClose]='true' [title]="'IMPORTAÇÃO DE MATRIZ'" (handleClose)="close()"></app-modal-header>
  <mat-dialog-content class="content-dialog">
    <form [formGroup]="searchMatrixForm" style="padding: 0;">
      <div class="form-inputs">
        <div class="form-pattern">
          <mat-form-field class="">
            <input matInput formControlName="courses.description" type="text" placeholder="Curso" (keyup)="loadMatrices()">
            @if (searchMatrixForm.controls['courses.description'].errors && searchMatrixForm.controls['courses.description'].touched) {
              <mat-error>
              {{searchMatrixForm.controls['courses.description'].errors['message']}}</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-pattern flex">
          <mat-form-field class="half-input">
            <input matInput formControlName="matrices.version" type="text" placeholder="Versão da Matriz" (keyup)="loadMatrices()">
            @if (searchMatrixForm.controls['matrices.version'].errors && searchMatrixForm.controls['matrices.version'].touched) {
              <mat-error>
              {{searchMatrixForm.controls['matrices.version'].errors['message']}}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="half-input">
            <input matInput formControlName="itineraries.version" type="text" placeholder="Versão do Itinerário" (keyup)="loadMatrices()">
            @if (searchMatrixForm.controls['itineraries.version'].errors && searchMatrixForm.controls['itineraries.version'].touched) {
              <mat-error>
              {{searchMatrixForm.controls['itineraries.version'].errors['message']}}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
    <form [formGroup]="importMatrixForm" style="padding: 0;">
      <div class="form-inputs">
        <p class="founded-matrices-title primary-text">Matrizes Encontradas</p>
        @if (!loading) {
          <div class="scroll">
            <mat-radio-group formControlName="matrix_id">
              @for (matrix of matrixArray; track matrix) {
                <mat-radio-button [value]="matrix.matrix_id" [disabled]="data.indexOf(matrix.matrix_id) > -1" (change)="changeMatrix()">
                  {{matrix.course_name}} - VERSÃO {{matrix.matrix_version}}, IN {{matrix.itinerary_version}} {{data.indexOf(matrix.matrix_id) > -1 ? '[IMPORTADA]' : ''}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        }
        @if (loading) {
          <div>
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>
        }
        <p class="founded-matrices-title primary-text">Associar a</p>
        <div class="form-pattern flex">
          <mat-form-field class="half-input">
            <mat-select matSelect formControlName="application_id" placeholder="Aplicação" required (selectionChange)="changeApplications($event)">
              @for (application of applicationArray; track application) {
                <mat-option [value]="application.id">
                  {{application.description}}
                </mat-option>
              }
            </mat-select>
            @if (importMatrixForm.get('application_id').errors && importMatrixForm.get('application_id').touched) {
              <mat-error>
              {{importMatrixForm.get('application_id').errors['message']}}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="half-input">
            <mat-select matSelect formControlName="course_id" placeholder="Curso" required (selectionChange)="changeCourses($event)">
              @for (course of courseArray; track course) {
                <mat-option [value]="course.id">
                  {{course.description}}
                </mat-option>
              }
            </mat-select>
            @if (importMatrixForm.get('application_id').touched && courseArray && courseArray.length == 0) {
              <mat-error>
              Nenhum Curso foi relacionado a Aplicação.</mat-error>
            }
            @if (importMatrixForm.get('course_id').errors && importMatrixForm.get('course_id').touched) {
              <mat-error>
              {{importMatrixForm.get('course_id').errors['message']}}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <div class="modal-footer">
    <button id="modalApplyBtn" type="button" mat-raised-button color="primary"
      class="far-left recover-btn secondary primary-text" (click)="importMatrix()" [disabled]="importMatrixForm.invalid || importMatrixForm.get('application_id').disabled ||
          importMatrixForm.get('course_id').disabled">
    Importar Matriz </button>
  </div>
}

@if (importing) {
  <app-modal-header [title]="'Importando...'"></app-modal-header>
  <mat-dialog-content class="content-dialog">
    @if (!cancel) {
      <p class="message primary-text">Importando Matriz de Referência. Caso você deseje interromper operação clique no botão "Cancelar Importação", todos os dados já importados serão descartados.</p>
    }
    @if (cancel) {
      <p class="message primary-text">Cancelando importação, aguarde.</p>
    }
    <div>
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
  </mat-dialog-content>
  <div class="modal-footer">
    @if (!cancel) {
      <button type="button" mat-raised-button color="primary" class="far-left cancel-btn secondary primary-text" (click)="cancelImport()"> Cancelar Importação </button>
    }
  </div>
}

